<template>
  <div>
    <el-card class='box-card'>
      <div slot='header' class='clearfix'>
        <span>{{ lbTypeTitle }}</span>
        <el-button style='float: right; padding: 3px 0' type='text' @click='handleKolJoinBatch'>批量添加</el-button>
      </div>
      <div>
        <el-table :data='KolDataList' highlight-current-row border
                  @selection-change='handleSelectionChange'
                  @sort-change='changeSelectionTableSort'
        >
          <el-table-column type='selection' width='55'></el-table-column>
          <el-table-column type='index' label='序号' width='65' align='center'></el-table-column>
          <!--          <el-table-column  label='排期ID' prop='id' width='100' align='center'></el-table-column>-->
          <el-table-column label='日期' prop='start_at' align='center' min-width='80' sortable='custom'>
            <template slot-scope='{row}'>
              <span>{{  row.start_at.slice(5, 10) }}</span>
            </template>
          </el-table-column>
          <el-table-column label='红人' prop='nickname' align='left' header-align="center" width='180'
          ></el-table-column>
          <el-table-column label='平台' prop='platform_code' align='center' min-width='100'>
            <template slot-scope='{row}'>
              <span>{{ row.platform_name || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label='链接' prop='start_at' align='center' width='100'
          >
            <template slot-scope='{row}'>
              <el-link type="primary" @click='routerLink(lbTypeCode,row.id)'>
                查看详情
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label='操作' min-width='80' align='center' fixed='right'>
            <template slot-scope='{row}'>
              <el-button type='text' @click='handleKolJoin(row)' icon='el-icon-shopping-bag-1'
              >添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'JoinToLb',
  inject: ['joinType'],
  data() {
    return {
      KolDataList: [],
      searchData: {},
      orderSort: { start_at: 'desc' },
      KolSelection: []
    }
  },
  props: {
    lbType: {
      type: [Number, String],
      required: true
    },
    lbTypeCode: {
      type: [String],
      required: true
    },
    lbTypeTitle: {
      type: [String]
    },
    productId: {
      type: [Number, String],
      required: true
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.KolSelection = val
    },
    changeSelectionTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getList()

    },
    handleQuery(searchData) {
      this.searchData = searchData
      this.getList()
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}
      if (this.searchData.ym) {
        condition.ym = this.searchData.ym
      }
      if (this.searchData.artist_id) {
        condition.artist_id = this.searchData.artist_id
      }
      if (this.searchData.progress_status) {
        condition.progress_status = this.searchData.progress_status
      }
      if (this.searchData.leader_id) {
        condition.leader_id = this.searchData.leader_id
      }
      if (this.searchData.leader_name) {
        condition.leader_name = this.searchData.leader_name
      }
      return condition
    },
    async getList() {
      const searchData = this.handleSearchCondition()
      Object.assign(searchData, { type: this.lbType, order: this.orderSort })
      const { list } = await this.$api.getLbScheduleMonthList(searchData)
      this.KolDataList = list
    },
    isDing() {
      const ua = window.navigator.userAgent
      return ua.indexOf('DingTalk') !== -1 // true or false
    },
    routerLink(type, id) {
      let name = ''
      if (type === 'kol') {
        name = 'lbKolDetail'
      } else {
        name = 'lbLiveDetail'
      }

      if (this.isDing()) {
        this.$router.push({
          name: name,
          params: { id: id }
        })
      } else {
        const { href } = this.$router.resolve({
          name: name,
          params: { id: id }
        })
        window.open(href, '_blank')
      }
    },
    async handleKolJoin(row) {
      const postData = {
        lb_id: row.id,
        product_ids: [this.productId]
      }
      await this.submitData(postData)

    },
    async handleKolJoinBatch() {
      const ids = this.KolSelection.map((i) => {
        return i.id
      })
      for (const item of ids) {
        const postData = {
          lb_id: item,
          product_ids: [this.productId]
        }
        await this.submitData(postData)
      }
    },
    async submitData(postData) {
      if (this.joinType && this.joinType === 2) {
        //加入视频号
        const id = await this.$api.appendVideoScheduleProducts(postData)
        if (id) {
          this.$message.success('添加视频号选品成功')
        }
      } else {
        // 加入产品库
        const id = await this.$api.appendLbScheduleProducts(postData)
        if (id) {
          this.$message.success('添加产品库选品成功')
        }
      }

    }
  }
}
</script>

<style scoped>

</style>
